import { useMemo } from "react";
import PiCreatorDropdown from "../../components/PiCreatorDropdown/PiCreatorDropdown";
import PiCreatorDropdownItem from "../../components/PiCreatorDropdown/PiCreatorDropdownItem";
import { PiInteractionDropdown } from "../../components/PiInteractionDropdown";
import ViewInArOutlinedIcon from "@mui/icons-material/ViewInArOutlined";

export default function ActorStateAttachmentTypeDropdown(props: {
  selected: boolean;
  onChange: (playerToProp: boolean) => void;
  style?: "default" | "small";
}) {
  const { selected, onChange, style = "default" } = { ...props };

  const getDropdownItems = () => {
    return [
      <PiCreatorDropdownItem
        key="prop-to-player"
        onClick={() => onChange(false)}
        text="Prop to Player"
      />,
      <PiCreatorDropdownItem
        key="player-to-prop"
        onClick={() => onChange(true)}
        text="Player to Prop"
      />,
    ];
  };

  const trigger = useMemo(() => {
    return (
      <PiCreatorDropdownItem
        text={selected ? "Player to Prop" : "Prop to Player"}
        icon={<ViewInArOutlinedIcon fontSize="inherit" color="inherit" />}
        onClick={() => {}}
      />
    );
  }, [selected]);

  const dropdown = useMemo(
    () => (
      <PiCreatorDropdown
        label={"Attachment Type"}
        style={style}
        trigger={trigger}
        items={getDropdownItems()}
      />
    ),
    [trigger, getDropdownItems, style]
  );

  return <>{dropdown}</>;
}
